import { apiClient, ApiType } from '@shared/apiClient';
import { CenterType } from '../../../../../../types/centerType';

export const formatDistance = (distanceInMeters?: number): string => {
  if (!distanceInMeters) return '';
  const km = Math.round(distanceInMeters / 1000);
  return ` (${km} km)`;
};

export const getUserLocation = (): Promise<GeolocationPosition> =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolokasjon støttes ikke av din nettleser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(pos),
      (geoError) => {
        let errorMessage = 'Kunne ikke hente din lokasjon.';
        switch (geoError.code) {
          case geoError.PERMISSION_DENIED:
            errorMessage =
              'Tilgang til lokasjonen din ble avvist. Du kan gå til innstillingene for nettleseren for å gi tilgang.';
            break;
          case geoError.POSITION_UNAVAILABLE:
            errorMessage = 'Informasjon om lokasjonen din er dessverre ikke tilgjengelig.';
            break;
          case geoError.TIMEOUT:
            errorMessage = 'Forespørselen om lokasjonen din tok for lang tid.';
            break;
          default:
            break;
        }
        reject(new Error(errorMessage));
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  });

export const fetchNearbyCenters = async (latitude: number, longitude: number): Promise<CenterType[]> => {
  const { data: nearbyCenters } = await apiClient.get<CenterType[]>(ApiType.apimNafNoApi, {
    url: `naf-centers/nearby?latitude=${latitude}&longitude=${longitude}`,
  });

  return nearbyCenters || [];
};

export const findNearestCenter = async (): Promise<{
  nearbyCenters: CenterType[];
  nearestCenter: CenterType | null;
}> => {
  const position = await getUserLocation();
  const { latitude, longitude } = position.coords;
  const nearbyCenters = await fetchNearbyCenters(latitude, longitude);

  return {
    nearbyCenters,
    nearestCenter: nearbyCenters.length > 0 ? nearbyCenters[0] : null,
  };
};
